import _Button from "@material-ui/core/esm/Button";
import React from 'react';
import classnames from 'classnames';
import { Tooltip } from 'swag-client-common/components/info/tooltip';
import productDetailsClasses from 'swag-client-common/styles/product-details.scss';
import { downloadFileInBrowser } from 'swag-client-common/utils/download-file-in-browser';
import { DesignUploadPanel } from '../../../design-upload-panel';
import CSSclasses from '../../details.scss';
import ProductDetailsNumber from '../product-details-number';
export const UploadLogos = ({
  number,
  imprintAreaTemplate,
  disabledTemplateButtonMessage,
  uploadDesignProductDetailsBlockHeader,
  isLimitedEdition,
  imprintAreaTemplateExists,
  classes,
  templateFileName
}) => {
  const downloadTemplate = async () => {
    if (!imprintAreaTemplate || !templateFileName) {
      return;
    }
    downloadFileInBrowser({
      url: imprintAreaTemplate,
      name: templateFileName
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(productDetailsClasses.block, productDetailsClasses.blockOverflowHidden)
  }, /*#__PURE__*/React.createElement("h5", {
    className: productDetailsClasses.blockTitle
  }, /*#__PURE__*/React.createElement(ProductDetailsNumber, {
    number: number
  }), uploadDesignProductDetailsBlockHeader), imprintAreaTemplateExists && /*#__PURE__*/React.createElement(Tooltip, {
    disableHoverListener: !disabledTemplateButtonMessage,
    title: disabledTemplateButtonMessage
  }, /*#__PURE__*/React.createElement(_Button, {
    "data-button": "Template",
    onClick: downloadTemplate,
    variant: "contained",
    disabled: Boolean(disabledTemplateButtonMessage),
    className: classnames(CSSclasses.button, classes.templateButton)
  }, "Template")), /*#__PURE__*/React.createElement(DesignUploadPanel, {
    isLimitedEdition: isLimitedEdition
  }));
};